export function convertFragmentToSegment(fragment) {
    const { duration, time } = fragment.sections[0];
    return {
        inpoint: time,
        outpoint: time + duration,
        duration: duration
    };
}
